import { EquipoModel } from '@/store/catalogos/equipo';
import { siguienteCalibracionModel } from '@/store/catalogos/siguienteCalibracion';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class EquipoPatronService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'equipoPatron';

  constructor(private http: HttpClient) { }

  getAll(): Observable<EquipoModel[]> {
    return this.http.get<EquipoModel[]>(this.baseUrl, httpOptions);
  }

  create(equipo: EquipoModel): Observable<EquipoModel> {
    return this.http.post<EquipoModel>(this.baseUrl, equipo, httpOptions);
  }

  update(equipo: EquipoModel): Observable<EquipoModel> {
    return this.http.put<EquipoModel>(`${this.baseUrl}/${equipo.idEquipo}`, equipo, httpOptions);
  }
  getIdEquipo(codigoEquipo: number): Observable<EquipoModel[]> {
    return this.http.get<EquipoModel[]>(
      `${this.baseUrl}/equipo/${codigoEquipo}`, httpOptions);
  }
  
  obtenerSiguienteCalibracion(clave: number): Observable<siguienteCalibracionModel> {
    return this.http.get<siguienteCalibracionModel>(`${this.baseUrl}/siguiente/${clave}`);
  }

}
